import { TVoice } from '@newo/api/gateway';
import { TVoiceOption } from '@/pages/Settings/components/Voice/Voice.types';

export const getVoiceOptions = (
    voices: TVoice[],
    language: string | null = 'en'
) => {
    if (language === 'en') {
        return voices.map((voice) => ({
            voice_id: voice.voice_id,
            name: voice.name,
            description: voice.description,
            preview_url: voice.preview_url,
            labels: Object.values(voice.labels)
        }));
    }

    return voices.reduce<TVoiceOption[]>((accumulator, voice) => {
        const voiceLanguage = voice.languages.find(
            (item) => item.language === language
        );

        if (voiceLanguage) {
            return [
                ...accumulator,
                {
                    voice_id: voice.voice_id,
                    name: voice.name,
                    description: voice.description,
                    preview_url: voiceLanguage.preview_url,
                    labels: Object.values(voice.labels)
                }
            ];
        }

        return accumulator;
    }, []);
};
